var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.104V8.07c0 .61.493 1.104 1.103 1.104H8.07a1.103 1.103 0 100-2.207H5.883a5.53 5.53 0 014.4-2.2 5.517 5.517 0 015.51 5.51 5.518 5.518 0 01-5.51 5.512 5.463 5.463 0 01-3.306-1.102 1.106 1.106 0 00-1.546.22 1.105 1.105 0 00.22 1.546A7.652 7.652 0 0010.28 18C14.534 18 18 14.534 18 10.278s-3.466-7.723-7.72-7.723a7.74 7.74 0 00-6.073 2.97V3.105a1.103 1.103 0 10-2.207 0z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default ForwardRef;